import { PagedFilter, PagedList, GeoLocation } from '../../common/common.types';
import { EventQuestionType } from '../event-questions/event-question.types';
import { QuoteParameter } from '../../pricing/price-matrix.types';
import { EventVertical, EventType } from '../../meta/meta.types';

export class EventRecommendationFilter extends PagedFilter {
	eventVerticalIds?: number[];
	eventTypeIds?: number[];
	answeredQuestions?: AnsweredQuestion[];

	startAtQuestionId?: number;
	seed?: number;
}

export class AnsweredQuestion {
	questionId: number;
	answerId: number;
}

export class EventRecommendations extends PagedList<EventRecommendation> {
	nextQuestion?: EventDiscoveryQuestion;
}

export class EventDiscoveryQuestion {
	questionId: number;
	type?: EventQuestionType;
	question: string;

	answers: EventDiscoveryAnswer[];
}

export class EventDiscoveryAnswer {
	answerId: number;
	answer: string;
}

export class EventRecommendation {
	experienceId: number;

	eventVertical: EventVertical;
	eventType: EventType;

	primaryImageUrl: string;
	secondaryImageUrl: string;

	name: string;
	tagline: string;
	summary: string;
	description: string;
	inclusions: string;
	location: string;

	quoting: EventRecommendationQuoting;
	activities?: EventRecommendationActivity[];
}

export class EventRecommendationQuoting {
	canQuote: boolean;

	minAttendees?: number;
	maxAttendees?: number;

	minResources?: number;
	maxResources?: number;

	minDuration?: number;
	maxDuration?: number;
	perDuration?: number;

	initialQuotes?: EventRecommendationQuote[];
}

export class EventRecommendationActivity {
	activityType: string;

	provider?: string;
	name: string;
	summary: string;

	startDay: number;
	startTime?: string;
	endDay: number;
	endTime?: string;
	isAllDay: boolean;

	location?: GeoLocation;
}

export class EventRecommendationQuote {
	isComplete: boolean;
	quoteAmount: number;
	currencyCode: string;
	missingParameters?: QuoteParameter[];
}
